const language: any = {
  send_image: "Отправить изображение",
  send: "Отправить",
  cancel: "Отменить",
  service: "Служба поддержки",
  send_to: "Отправить кому",
  reply: "Ответить",
  copy: "Копировать",
  select_message: "Сначала выберите сообщение",
  view_user: "Посмотреть информацию о пользователе",
  merge_forward: "Переслать с объединением",
  item_forwarding: "Переслать по пунктам",
  delete: "Удалить",
  forward: "Переслать",
  search: "Поиск",
  chat_recently: "Недавние чаты",
  friend: "Друг",
  affirm: "Подтвердить",
  file: "Файл",
  chartlet: "Стикер",
  remove_from_the_group: "Вас исключили из группового чата",
  everyone_is_silent:
    "Вы отключены от чата или установлен режим тишины для всех",
  system_error: "Системная ошибка",
  motion_graph: "Анимация",
  chatting_records: "История чатов",
  group_chatting_records: "История групповых чатов",
  message_is_encrypted:
    "Это сообщение зашифровано от конца до конца, его нельзя расшифровать на веб",
  moth: "Месяц",
  day: "День",
  message_does_not_support_viewing:
    "Это сообщение нельзя просмотреть, откройте на мобильном устройстве для подробностей",
  tips: "Подсказка",
  cannot_be_longer_than_1000_characters:
    "Длина введенного текста не может превышать 1000 символов!",
  ctrl_enter: "Нажмите Ctrl + Enter для новой строки, Enter для отправки",
  account: "Аккаунт",
  enterprise_code: "Код предприятия",
  common_problem: "Часто задаваемые вопросы",
  join_the_organization: "Присоединиться к организации",
  complete: "Завершить",
  unknown_error: "Неизвестная ошибка",
  "404": "Запрашиваемый адрес не найден (404)",
  the_day_before: "Позавчера",
  yesterday: "Вчера",
  just_now: "Только что",
  sunday: "Воскресенье",
  monday: "Понедельник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четверг",
  friday: "Пятница",
  saturday: "Суббота",
};

export default language;
